var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgBenefitsTips = function SvgBenefitsTips(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 80,
    height: 80
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "BenefitsTips_svg__a",
    d: "M64.28 32.655c-.727-7.237-1.013-11.366-2.507-32.348-7.212 4.605-7.165 4.32-9.711 5.664C49.06 3.668 38.76 1.013 31.819 1.013 14.246 1.013 0 15.464 0 33.299s14.246 32.279 31.819 32.279S66.06 50.398 64.28 32.655"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h80v80H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BEEBFF",
    d: "M70.87 45.709c-.723-7.318-1.007-11.493-2.491-32.709-7.166 4.656-7.12 4.369-9.65 5.727-2.983-2.328-13.216-5.013-20.113-5.013C21.155 13.714 7 28.326 7 46.36 7 64.395 21.155 79 38.616 79S72.638 63.65 70.87 45.709"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(7 13)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "BenefitsTips_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#BenefitsTips_svg__a"
  })), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    mask: "url(#BenefitsTips_svg__b)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.964 14.581)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#00A1DE",
    d: "m29.095.345 2.221 9.762-2.151 17.436-8.458-.851-.116-17.314.596-7.114z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EE8700",
    d: "M5.146 19.409s3.203.898 4.287 9.286c1.083 8.388 3.946 28.08 4.395 31.327.812 5.817 1.076 8.065 1.076 8.065L41.074 66c-.21-1.343.72-10.744.665-21.45 0-8.442.387-9.87.851-17.997.736-12.893 2.57-13.66 2.57-13.66L31.602 9.209s2.128 3.254-.379 11.581c-1.215 4.021-3.42 9.739-4.31 8.51-8.875-12.278-7.738-19.323-7.738-19.323s-6.701 1.696-10.872 2.51c-3.73.751-4.24 4.128-3.157 6.922"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFA100",
    d: "M44.664 12.947c-.286-.07 1.03-2.832 6.19 13.537 1.703 5.373 2.903 12.94 1.889 15.94-.557 1.643-10.392 16.116-13.51 19.777-2.965 3.5-8.869 3.37-8.869 3.37l.418-2.833s14.192-21.91 13.604-22.255c2.468 1.304-2.012-8.826-4.527-12.809-6.485-10.314 4.805-14.727 4.805-14.727"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFA100",
    d: "m51.273 30.337-.325 2.064-10.37-1.634c2.067 5.372 2.987 10.46 3.328 10.644.588.307-14.625 23.745-14.625 23.745l.604 1.312s5.904.13 8.875-3.369c3.095-3.676 12.946-18.135 13.503-19.785.836-2.478.433-8.058-.99-12.977"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00A1DE",
    d: "m29.095.345 2.221 9.762-2.151 17.436-8.458-.851-.116-17.314.596-7.114z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFA100",
    d: "M26.201 22.54c.488.383 1.037-8.588 1.037-8.588l9.286-2.862-7.738 24.62-14.478-24.106 6.113-2.172 3.954 4.52s1.346 8.204 1.826 8.588"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EE8700",
    d: "M5.146 19.409s3.203.898 4.287 9.286c1.083 8.388 3.946 28.08 4.395 31.327.812 5.817 1.076 8.065 1.076 8.065L41.074 66c-.21-1.343.72-10.744.665-21.45 0-8.442.387-9.87.851-17.997.736-12.893 2.57-13.66 2.57-13.66L31.602 9.209s2.128 3.254-.379 11.581c-1.215 4.021-3.42 9.739-4.31 8.51-8.875-12.278-7.738-19.323-7.738-19.323s-6.701 1.696-10.872 2.51c-3.73.751-4.24 4.128-3.157 6.922"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 22.702,
    cy: 21.987,
    r: 1,
    fill: "#00608B",
    transform: "rotate(-31.37 22.702 21.987)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFC673",
    d: "M18.378 12.28a.4.4 0 0 0 .108-.277 5.8 5.8 0 0 1 .913-2.303c.202-.306.465-.567.774-.767.627.844 1.037 1.535 1.703 2.302.773.967 2.46 2.725 2.46 2.725-.317.767-1.284 6.193-1.284 6.193s-4.24-7.268-4.674-7.874Zm14.772.122a.44.44 0 0 1-.116-.276 5.85 5.85 0 0 0-.82-2.449 2.6 2.6 0 0 0-.813-.767c-.627.844-1.037 1.535-1.702 2.302-.813.967-2.46 2.725-2.46 2.725.316.767 1.284 6.193 1.284 6.193s4.194-7.137 4.627-7.728"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFA100",
    d: "M26.201 22.54c.488.383 1.037-8.588 1.037-8.588l9.286-2.862-7.738 24.62-14.478-24.106 6.113-2.172 3.954 4.52s1.346 8.204 1.826 8.588"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFC673",
    d: "M18.378 12.28a.4.4 0 0 0 .108-.277 5.8 5.8 0 0 1 .913-2.303c.202-.306.465-.567.774-.767.627.844 1.037 1.535 1.703 2.302.773.967 2.46 2.725 2.46 2.725-.317.767-1.284 6.193-1.284 6.193s-4.24-7.268-4.674-7.874Zm14.772.122a.44.44 0 0 1-.116-.276 5.85 5.85 0 0 0-.82-2.449 2.6 2.6 0 0 0-.813-.767c-.627.844-1.037 1.535-1.702 2.302-.813.967-2.46 2.725-2.46 2.725.316.767 1.284 6.193 1.284 6.193s4.194-7.137 4.627-7.728"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFA100",
    d: "M13.813 27.973.944 38.043s-2.399 11.71 4.163 11.227c2.608-.192 4.736-2.878 4.736-2.878l8.937-12.724z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#64C6F1",
    d: "M24.979 22.755s2.824-1.09 3.598-1.251 1.385-.261 1.424-.046c.17.574-.1 1.187-.643 1.45-.828.369-4.38-.153-4.38-.153Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#94541E",
    d: "m12.226 7.567 26.372 28.35.085-1.175L13.302 6.354z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 40.161,
    cy: 33.407,
    fill: "#50B3E4",
    rx: 9.108,
    ry: 9.033
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0089C2",
    d: "M41.732 35.985a8.97 8.97 0 0 0-4.264 6.025 9.14 9.14 0 0 0 6.917-.606 9 9 0 0 0 4.458-5.28q.162-.49.255-.998a9.12 9.12 0 0 0-7.366.86ZM35.51 25.648a8.97 8.97 0 0 0-4.264 6.024 9.14 9.14 0 0 0 6.918-.605 9 9 0 0 0 4.457-5.281q.163-.49.256-.998a9.1 9.1 0 0 0-7.367.86"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#94541E",
    d: "m8.063 11.489 30.04 24.496-.07-1.166L8.96 10.146z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4DB5E6",
    d: "M16.621 29.063a26 26 0 0 0 1.819-2.97 6.77 6.77 0 0 1 2.933-2.9c.874-.285 1.013-.945 4.201-.576l6.787.767s.828 1.297-.542 1.627a1.403 1.403 0 0 1-1.346 1.328l-.48.1a1.536 1.536 0 0 1-1.184 1.672 3.5 3.5 0 0 1-2.685 1.927c-2.12.406-4.713.767-4.976.875s-2.522 4.282-2.522 4.282-1.95-6.262-2.005-6.132"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFC673",
    d: "M17.573 37.85c.201-.468 2.84-2.033 3.343-4.167.147-.63 1.997-2.533 2.066-2.77.07-.238-1.106-1.658-2.09-2.909a24 24 0 0 0-2.065-2.678c-.387-.261-.65.13-1.045.115q-.921.067-1.842 0c-.91.003-1.81.2-2.638.575a2.46 2.46 0 0 1-1.246-.23 5.3 5.3 0 0 0 .905 3.07 37 37 0 0 1 3.428 7.981c.488 1.535 1.184 1.013 1.184 1.013"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFA100",
    d: "M2.26 22.018c-.109.69-2.933 18.503-.503 18.557l7.738 3.323 1.764-22.333s-.124-10.145-4-8.718c-3.723 1.374-4.164 4.037-5 9.17Z"
  })))), /*#__PURE__*/React.createElement("path", {
    fill: "#4AB7E4",
    fillRule: "nonzero",
    d: "M30.846 17a8 8 0 0 0-2.738.527c-.522.312.997 3.772 1.408 4.683.07.172.191.318.348.415a1.96 1.96 0 0 0 1.702 0c1.519-.56-.72-5.593-.72-5.593zm16.314.36a7.8 7.8 0 0 1 2.706.303c.53.264-.664 3.74-.989 4.658a1 1 0 0 1-.3.432 1.95 1.95 0 0 1-1.662.112c-1.52-.432.245-5.505.245-5.505"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4AB7E4",
    fillRule: "nonzero",
    d: "M36.33 8.078S32.46 12.26 31 15.106c.781.725.938.862.938.862a35.3 35.3 0 0 0 0 7.012c.422 2.915 3.047 6.791 3.047 6.791a4.9 4.9 0 0 0-.226 2.152c1.219.763 3.298 3.357 5.689 3.052s5.056-3.815 7.134-15.108C49.662 8.574 43.675 2.561 36.345 8.07z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4AB7E4",
    fillRule: "nonzero",
    d: "M41.342 8.089S46.58 5.292 48 8.166c-.76.732-2.379 7.89-2.379 7.89a37.3 37.3 0 0 1 0 7.08c-.403 2.944-2.964 6.858-2.964 6.858a3.47 3.47 0 0 1 1.057 2.412c-1.186.77-3.382 2.859-5.708 2.566s-5.578-3.583-7.6-14.971 3.8-17.476 10.929-11.912z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00A1DB",
    fillRule: "nonzero",
    d: "M44.977 24.788a1.57 1.57 0 0 1-.798 1.048 1.44 1.44 0 0 1-1.277.029 1.47 1.47 0 0 1-.902-1.33 1.58 1.58 0 0 1 .554-1.195c.347-.291.8-.403 1.234-.305.381.061.723.283.947.613s.311.742.242 1.14"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#003449",
    fillRule: "nonzero",
    d: "M35.003 19.891c-.039.503.33.958.875 1.079.545.12 1.107-.127 1.334-.588a.89.89 0 0 0-.086-.875 1.1 1.1 0 0 0-.835-.457c-.612-.076-1.18.296-1.288.841m6.02-.133a.8.8 0 0 0 .187.64c.156.182.386.3.64.328.262.038.53-.02.745-.161a.88.88 0 0 0 .395-.59.79.79 0 0 0-.186-.64.97.97 0 0 0-.642-.327 1.06 1.06 0 0 0-.724.17.86.86 0 0 0-.377.58z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00A1DB",
    fillRule: "nonzero",
    d: "M34.004 24.356c-.031.457.134.904.45 1.22.317.316.752.468 1.186.413a1.5 1.5 0 0 0 1.285-.996c.14-.438.081-.919-.16-1.304a1.42 1.42 0 0 0-1.078-.673c-.806-.122-1.555.456-1.683 1.299z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#008CCC",
    fillRule: "nonzero",
    d: "M38.017 25.803c.13.255 2.342.329 3.738-.188.366-.132.213-.345.213-.345L39.78 20s-1.983 4.72-1.762 5.803Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#884F12",
    fillRule: "nonzero",
    d: "M38.055 13.749s.929 2.804 0 2.63a10.3 10.3 0 0 0-4.987.621l-.685-2.115s1.857-1.364 5.672-1.106zm3.17-.008s-.613 2.88.331 2.66a10.4 10.4 0 0 1 5.027.167L47 14.37s-1.99-1.182-5.766-.591zm4.658-9.997c-7.23-5.336-23.207 3.198-17.78 4.01 5.429.81 14.948-1.69 14.948-1.69z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#008CCC",
    fillRule: "nonzero",
    d: "m48.489 17.242-1.102 3.773c0 .06-1.487 5.775-8.764 5.775-3.21 0-6.333-4.122-7.442-5.744-.189-.891-.606-3.02-.685-4.046l-.495.71a13.8 13.8 0 0 0 .283 2.936l.96 4.34c3.029 10.778 7.167 11.963 8.323 12.008 2.14.098 3.572-1.034 5.641-5.283C47.427 27.129 49 18.774 49 18.774z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#003449",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.02,
    d: "M35 28.185s3.366 4.204 9-.185"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#884F12",
    fillRule: "nonzero",
    d: "M48.006 5.915C46.613 2.127 42.272 2.214 43.518 2c-4.805.848-19.98 5.73-19.507 8.36.178.991 4.031.682 5.633 0 .209 2.972.302 5.318.302 5.318l.123 1.847a10.05 10.05 0 0 0 2.469-6.435c5.795-.547 13.34-3.67 13.34-3.67s-1.548 1.276-.983 1.514 1.826-.792 1.826-.792a62 62 0 0 0 1.285 9.446l.688.412s1.03-7.41-.688-12.085"
  }))));
};
export default SvgBenefitsTips;